import { ChipProps } from './chip.models';
import * as S from './chip.style';

export const Chip: React.FC<ChipProps> = ({ children, ...styleProps }) => (
  <S.ChipStyle {...styleProps}>{children}</S.ChipStyle>
);
